<template>
  <div>
    <ToggleOption
      label="Owned"
      :disabled="!backend.userLoggedIn"
      :tooltip="
        backend.userLoggedIn
          ? 'Browse only configurations belonging to you'
          : err('Log in to filter by user')
      "
      v-model="filters.owned"
    />
  </div>
</template>

<script setup lang="ts">
import { err } from "@/utils";
import { useBackendStore, useConfigFiltersStore } from "@/stores";
import ToggleOption from "@/components/settings/ToggleOption.vue";

const backend = useBackendStore();
const filters = useConfigFiltersStore();
</script>
